<template>
  <button
    class="link text-sm"
    :aria-label="`Nutrition info for ${ productTitle }`"
    data-gtm-action="show nutrition info"
    :data-gtm-label="productTitle"
    @click.prevent="modalActive = true"
  >
    {{ $t('bundler.nutrition_info') }}
  </button>
  <vue-modal
    v-model="modalActive"
    @close="modalActive = false"
  >
    <div class="modal-content">
      <h2 class="modal-title">
        {{ productTitle }}
      </h2>
      <div>
        <ResponsiveImage
          v-if="image"
          :image="image"
          :width="400"
          :alt="alt"
          class="w-64"
          tabindex="0"
        />
        <img
          v-else-if="src"
          class="w-64"
          :src="src"
          :alt="alt"
          :width="width"
          :height="height"
          tabindex="0"
        >
        <p
          class="mt-2 text-gray-800 text-xs text-left font-semibold uppercase leading-4"
          v-html="$t('products.no_artificial')"
        />
      </div>
    </div>
  </vue-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'
import type { MediaImage } from '@/types/shopify'
export interface Props {
  productTitle: string
  image?: MediaImage
  src?: string
  width?: number | string
  height?: number | string
  alt: string
}
defineProps<Props>()
const modalActive = ref(false)
</script>
